import React from 'react';
import { Card, CardImg, CardImgOverlay } from 'reactstrap';
import Css from './ThingsToDoTile.scss';
import { Link } from 'react-router-dom';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/experiences/clouds.jpg');

const Tile = props => {
  return (
    <div className={'mt-3 px-2 col-md-3 col-xs-12 pointer'}>
      {props.city === 'exclusive' && props.locked === true ? (
        <Card className={Css.Tile + ' border-0 text-center'}>
          <CardImg className="card-img-top" src={Clouds} alt="Card image cap" />

          <CardImgOverlay
            className={
              'p-2 text-center d-flex align-items-center ' + Css.Overlay
            }
          >
            <button
              className={'btn btn-fullred mx-auto'}
              onClick={props.toggleModal}
            >
              UNLOCK
            </button>
          </CardImgOverlay>
        </Card>
      ) : (
        <Link
          to={
            props.city === 'exclusive'
              ? '/exclusive-experience'
              : '/jetsuite-experiences/' + props.city
          }
          className={'d-block'}
          onClick={() => {
            window.gtag('event', 'click', {
              event_category: 'JS-Experiences-Engagement',
              event_label: 'Landing - ' + props.FrameHeader
            });
          }}
        >
          <Card className={Css.Tile + ' border-0 text-center'}>
            <CardImg
              className="card-img-top"
              src={props.ImgUrl}
              alt="Card image cap"
            />

            <CardImgOverlay
              className={
                'p-2 text-center d-flex align-items-center ' + Css.Overlay
              }
            >
              <div className={'align-middle ' + Css.OverlayText}>
                <p className={Css.Header + ' mb-2 font-md'}>
                  {props.FrameHeader}
                </p>

                <p className={Css.Text + ' font-sm'}>{props.FrameText}</p>
              </div>
            </CardImgOverlay>
          </Card>
        </Link>
      )}
    </div>
  );
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/Experiences/ThingsToDoTile/ThingsToDoTile.js